import { render, staticRenderFns } from "./ErrorEmailRecover.vue?vue&type=template&id=ee74d71c&"
import script from "./ErrorEmailRecover.vue?vue&type=script&lang=ts&"
export * from "./ErrorEmailRecover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports